import styled from 'styled-components';

export const StyledPaymentRowWrraper = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;

    .form-control {
        width: 150px;
    }

    .dropdown {
        width: 200px;
    }
`